import {
    EQUIPMENT_ADDON,
    EQUIPMENT_GROUP_BIKE_RACK,
    PRICING_STRATEGY_PER_BOOKING_NIGHT,
    SERVICE_ADDON,
    TYPE_EQUIPMENT_ADDON,
    TYPE_SERVICE_ADDON,
    PRICE_TYPE_INCLUDED,
} from '~/config/productTypes';

export default {
    methods: {
        equipmentAddons(addons) {
            return addons?.filter(addon => addon.type === TYPE_EQUIPMENT_ADDON);
        },
        serviceAddons(addons) {
            return addons?.filter(addon => addon.type === TYPE_SERVICE_ADDON);
        },
        isAddonIncluded(addon) {
            return addon.priceType === PRICE_TYPE_INCLUDED;
        },
        priceText(addon) {
            if (!addon.currency) {
                return '';
            }

            const formattedPrice = this.formattedPrice(addon.purchasePrice, addon.currency, 2);

            if (addon.pricingStrategy === PRICING_STRATEGY_PER_BOOKING_NIGHT) {
                return this.$t('pages.vehicle.addon_price_per_night', { price: formattedPrice });
            }

            return this.$t('pages.vehicle.addon_price_per_booking', { price: formattedPrice });
        },
        isBikeRackAddon(key) {
            return EQUIPMENT_ADDON[key] && EQUIPMENT_ADDON[key].group === EQUIPMENT_GROUP_BIKE_RACK;
        },
        serviceIconName(key) {
            if (!key || (key && !SERVICE_ADDON[key])) {
                return '';
            }

            return SERVICE_ADDON[key].icon;
        },
        equipmentIconName(key) {
            if (!key || (key && !EQUIPMENT_ADDON[key])) {
                return '';
            }

            return EQUIPMENT_ADDON[key].icon;
        },
        bikeRackCapacity(key) {
            const extractedCapacity = key && key.split('_').pop();
            const capacity = isNaN(extractedCapacity) ? '-' : parseInt(extractedCapacity);

            return this.$t('pages.vehicle.equipment_addon.bike_rack_capacity', { capacity });
        },
        /**
         * Orders addons by title. Included addons are last ones.
         *
         * @param {Array} addons
         * @returns {Array}
         */
        orderAddonsByTitle(addons) {
            return addons.sort((a, b) => {
                const aIncluded = this.isAddonIncluded(a);
                const bIncluded = this.isAddonIncluded(b);

                if (aIncluded !== bIncluded) {
                    return aIncluded ? 1 : -1;
                }

                // If both have the same included status, sort by title
                const aTitle = this.$t(`pages.vehicle.${a.type}.${a.key}`);
                const bTitle = this.$t(`pages.vehicle.${b.type}.${b.key}`);

                return aTitle.localeCompare(bTitle);
            });
        },
    },
};
